import { collection, query, where, orderBy, limit } from 'firebase/firestore';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { size as _size } from 'lodash-es';
import { authFire, dbFirestore } from '../appFirebase';
import { addDocToCollection, getQueryData } from './dbUtils';

export const getAssessments = async () => {
	const assessmentsRef = collection(dbFirestore, 'assessments');
	const assessmentsQ = query(
		assessmentsRef,
		where('status', '==', 'active'),
		orderBy('modifiedDate', 'desc'),
		limit(1)
	);
	const assessmentsResults = await getQueryData(assessmentsQ, 'assessmentId');
	if (_size(assessmentsResults)) {
		return assessmentsResults[0];
	}
};

export const getAssessmentDetails = assessmentId => {
	const assessmentRef = doc(dbFirestore, 'assessments', assessmentId);
	return getDoc(assessmentRef).then(docSnap => {
		if (docSnap.exists()) {
			return { ...docSnap.data(), assessmentId };
		}
		return null;
	});
};




